export default __webpack_public_path__ + "49e35aa91efa645e9cf565c6d79f4613.webp";